export default class DtoProjection {
    constructor(obj) {
        this.field = obj.field
        this.code = obj.code
        this.name = obj.name
    }
}